import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useApi } from '../../hooks/useApi';
import { ForumApplication, ApiForumApplication } from '../../models/ForumApplication';
import Spinner from '../../components/Spinner';
import { toast } from 'react-toastify';
import AppliedPostCard from './AppliedPostCard';

const DonorApplicationList = () => {
  const [ applications, setApplications ] = useState<ForumApplication[]>();
  const { get, loading } = useApi();

  useEffect(() => {
    get({
      endpoint: 'api/v1/forum_applications/mine',
      onSuccess: (res) => {
        setApplications((res.data as ApiForumApplication[]).map(a => new ForumApplication(a)));
      },
      onError: () => { toast.error('応募一覧の取得に失敗しました'); },
    });
  }, [ get ]);

  if (loading || !applications) return <Spinner centered={ true } />;

  return (
    <section className="donor_forum">
      <h2 className="main_title"><span>自分の応募一覧</span><Link to="/forum" className="forum_link">掲示板を見る</Link></h2>
      { applications.length === 0 ? (
        <p>応募した募集はまだありません。</p>
      ) : (
        <ul className="dp-list">
          { applications.map(app => (
            <AppliedPostCard key={ app.id } application={ app } />
          )) }
        </ul>
      ) }
    </section>
  );
};

export default DonorApplicationList;
